import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./fundManagementhistory.css";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { checkPermission, formatNumberWithCommas, getSelectList } from "../../config/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fundTransactionFilter } from "../../config/utils";
import moment from "moment";
import { emptyFundTransactionList, exportFundDetails, getFundTransactionDetails, getSuperAdminUsers } from "../../store/actions/fundManagement";
import Button from "bootstrap-4-react/lib/components/Button";
import BatchPagination from "../batch/BatchPagination";
import LoaderSpinner from "../common/Loader";
import TopUpModal from "../modal/TopUpModal";
import PriceAdjustModal from "../modal/priceAdjustModal/adjustModal";
import RechargeWallet from "../modal/RechargeWallet";
import { fetchAllCompanyDetails } from "../../store/actions/rateCard";
import SearchProduct from "../Inventory/Product/searchProduct";
import { toast } from "react-toastify";
import { featureSubmodulePermission, permssionAdjustment, permssionTopUp, settings, SUBF_FUNDMANAGEMENT } from "../../constant";
import TopUpIconWhite from "../../assets/topUpWhite.svg";
import AdjustmentIconWhite from "../../assets/adjustmentIconWhite.svg";
import PropTypes from "prop-types";

const getTopUpRefreshFilter = (currentPage, numberOfPage, formData, userDetails) => ({
  pageIndex: currentPage,
  pageSize: numberOfPage,
  sortColumn: formData.sortColumn,
  sortOrder: formData.sortOrder,
  searchKey: formData.searchText || '',
  topupCompanyId: userDetails?.Value?.companyId,
  topupSellerId: userDetails?.Value?.sellerId,
  role: userDetails?.Value?.role,
  isAdmin: userDetails?.Value?.isAdmin,
  isCurrentUser: true,
});

const getSelectedTopUpFundList = (formData) => {
  if (!formData?.topupCompanyId || !formData?.topupSellerId) return [];
  return [{
    id: formData.creditCompanySellerId,
    companyId: formData.topupCompanyId,
    sellerId: formData.topupSellerId,
    isChecked: true,
  }];
};

const FundHistoryHeaderActions = ({
  employeePermissions,
  handleApply,
  handleBack,
  handleDownloadExport,
  openAdjustmentModal,
  openTopUpModal,
  showLoader,
}) => (
  <div className="top_right_button_container">
    <Button
      className="cus-seconday-bg-btn openSearch mr-2"
      onClick={handleDownloadExport}
      disabled={showLoader}
    >Export</Button>
    {checkPermission(settings, SUBF_FUNDMANAGEMENT, permssionTopUp, featureSubmodulePermission, employeePermissions) && (
      <Button
        className="cus-seconday-bg-btn top-btn fullIconBtn"
        onClick={openTopUpModal}
        id="topUpBtn"
      >
        <img src={TopUpIconWhite} alt="" className="mr-1" /> Top Up
      </Button>
    )}
    {checkPermission(settings, SUBF_FUNDMANAGEMENT, permssionAdjustment, featureSubmodulePermission, employeePermissions) && (
      <Button
        className="cus-seconday-bg-btn top-btn ajustmentBtn fullIconBtn"
        onClick={openAdjustmentModal}
        id="ajustmentBtn"
      >
        <img src={AdjustmentIconWhite} alt="" className="mr-1" /> Adjustment
      </Button>
    )}
    <Button
      className="cus-seconday-bg-btn top-btn"
      onClick={() => handleApply()}
    >
      Apply
    </Button>
    <Button
      className="cus-seconday-bg-btn top-btn resetBtn"
      onClick={() => handleApply("reset")}
    >
      Reset <i className="fa fa-refresh" aria-hidden="true"></i>
    </Button>
    <Button
      className="cus-primary-transparent-btn"
      onClick={handleBack}
    >
      Back
    </Button>
  </div>
);

FundHistoryHeaderActions.propTypes = {
  employeePermissions: PropTypes.array,
  handleApply: PropTypes.func,
  handleBack: PropTypes.func,
  handleDownloadExport: PropTypes.func,
  openAdjustmentModal: PropTypes.func,
  openTopUpModal: PropTypes.func,
  showLoader: PropTypes.bool,
};

const FundHistoryModals = ({
  activeSellerList,
  dispatch,
  modalShow,
  priceModalShow,
  selectedTopUpFundList,
  setModalShow,
  setpriceModalShow,
  setShowRechargePopup,
  showRechargePopup,
  topUpRefreshFilter,
  userDetails,
}) => (
  <>
    {modalShow && (
      <TopUpModal
        show={modalShow}
        showModal={modalShow}
        activeSellerList={activeSellerList}
        onHide={() => setModalShow(false)}
        fundList={selectedTopUpFundList}
        filterData={topUpRefreshFilter}
      />
    )}

    {priceModalShow && (
      <PriceAdjustModal
        show={priceModalShow}
        activeSellerList={activeSellerList}
        onHide={() => setpriceModalShow(false)}
      />
    )}
    {showRechargePopup && (
      <RechargeWallet
        showModal={showRechargePopup}
        userDetails={userDetails}
        setShowRechargePopup={setShowRechargePopup}
        dispatch={dispatch}
      />
    )}
  </>
);

FundHistoryModals.propTypes = {
  activeSellerList: PropTypes.array,
  dispatch: PropTypes.func,
  modalShow: PropTypes.bool,
  priceModalShow: PropTypes.bool,
  selectedTopUpFundList: PropTypes.array,
  setModalShow: PropTypes.func,
  setpriceModalShow: PropTypes.func,
  setShowRechargePopup: PropTypes.func,
  showRechargePopup: PropTypes.bool,
  topUpRefreshFilter: PropTypes.object,
  userDetails: PropTypes.object,
};

export function FundmanagementHistory(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fetchAllCompany = useSelector(
    (state) => state.RateCardReducer?.fetchAllCompany
  );
  const [totalPages, setTotalPages] = useState(1);
  const [superAdmins, setSuperAdmins] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [filterError, setFilterError] = useState('');
  const numOfPage = [30, 50, 100, 200, 500, 1000, 2000];
  const [currentPage, setCurrentPage] = useState(1);
  const [filterTransactionType, setfilterTransactionType] = useState();
  const [numberOfPage, setNumberOfPage] = useState(30);
  const [modalShow, setModalShow] = React.useState(false);
  const [priceModalShow, setpriceModalShow] = React.useState(false);
  const [showRechargePopup, setShowRechargePopup] = React.useState(false);
  const [activeSellerList, setActiveSellerList] = useState([]);
  const [fundTransactionData, setFundTransactionData] = useState([]);
  const location = useLocation();
  const data = location?.state?.rowData;
  const userValue = location?.state?.userData;
  const isIncludeAllData = location?.state?.includeAllData;
  const UserDetails = useSelector((state) => state.auth.user);
  const currentDate = new Date();
  const sevenDaysBefore = new Date(
    currentDate.getTime() - 7 * 24 * 60 * 60 * 1000
  );
  // Format the date to a string in a desired format (e.g. ISO string)
  const dateValue = sevenDaysBefore.toISOString();
  const date = new Date(dateValue);
  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short",
    timeZone: "Asia/Kolkata",
  };
  const formattedDate = date.toLocaleString("en-US", options).replace(/,/g, ""); // NOSONAR
  let currentDateValue = new Date();

  const [formData, setFormData] = useState({
    searchKeyword: '',
    sortColumn: '',
    sortOrder: 'DESCENDING',
    userDetail: null,
    actionByUserId: 0
  });

  useEffect(() => {
    if (fetchAllCompany?.length) {
      let data = fetchAllCompany?.map((item) => {
        return {
          ...item,
          value: item.Id,
          label: item.name,
        };
      });
      setActiveSellerList(data);
    }
  }, [fetchAllCompany]);

  useEffect(() => {
    let companyData = {
      screenType: 2,
    }
    dispatch(fetchAllCompanyDetails(companyData));
    fetchSuperAdminUsers();
  }, [userValue]);

  useEffect(() => {
    setFormData({
      availableAmount: data?.availableAmount || userValue?.balanceAmount,
      topupCompanyId: data?.topupCompanyId,
      topupSellerId: data?.topupSellerId,
      companyName: data?.companyName || userValue?.companyName,
      id: 0,
      sellerName: data?.sellerName || userValue?.sellerName,
      threshold: data?.threshold || userValue?.threshold,
      dateFrom: new Date(formattedDate),
      dateTo: currentDateValue,
      creditCompanySellerId: data?.creditCompanySellerId || 0,
      includeAllData: isIncludeAllData || false,
    });
  }, [location?.state?.currentView]);

  const fundTransactionDetails = useSelector(
    (state) =>
      state?.FundManagementReducer?.getTransactionDetails?.Entity
        ?.listFundMasterDetailsEntity
  );

  const fundTransactionTotalRecord = useSelector(
    (state) => state?.FundManagementReducer?.getTransactionDetails?.Entity
  );

  const [formatDateValue, setFormatDateValue] = useState();
  const [currentDateVal, setcurrentDateVal] = useState();

  const handleDateChange = (item, name) => {
    if (name === "dateFrom") {
      setFormatDateValue(item);
      setFormData({ ...formData, [name]: item });
    } else if (name === "dateTo") {
      setcurrentDateVal(item);
      setFormData({ ...formData, [name]: item });
    }
    setFilterError('');
    setTotalPages(1);
  };

  useEffect(() => {
    if (formData?.creditCompanySellerId > -1) {
      dispatch(
        getFundTransactionDetails(
          formData,
          setTotalPages,
          numberOfPage,
          currentPage,
          filterTransactionType?.value,
          setShowLoader
        )
      );
    }
  }, [formData.sortOrder, formData.sortColumn, numberOfPage, currentPage, location?.state?.currentView, formData?.creditCompanySellerId]);

  useEffect(() => {
    setFormatDateValue(formattedDate);
    setcurrentDateVal(currentDateValue);
    const visibleTransactionFilter = UserDetails.Value.isSuperAdmin ? fundTransactionFilter : fundTransactionFilter.filter(
      (item) => ![7, 8, 14].includes(item.value) // hide CREDIT VIP & EASYPOST for non-super admin
    );
    setFundTransactionData(visibleTransactionFilter);
  }, []);

  const handleApply = (type) => {
    if (type === "reset") {
      setfilterTransactionType(0);
      setCurrentPage(1);
      dispatch(
        getFundTransactionDetails(
          {
            ...formData,
            actionByUserId: 0,
            userDetail: null,
            searchText: '',
            dateFrom: moment(formattedDate).startOf('day'),
            dateTo: moment(currentDateValue).startOf('day'),
          },
          setTotalPages,
          numberOfPage,
          1,
          0,
          setShowLoader
        )
      );
      setNumberOfPage(30)
      setCurrentPage(1)
      setTotalPages(1)
      setFormData({
        ...formData,
        searchText: '',
        dateFrom: new Date(formattedDate),
        dateTo: currentDateValue,
        actionByUserId: 0,
        userDetail: 0,
      });
      setFormatDateValue(formattedDate);
      setcurrentDateVal(currentDateValue);
      setFilterError('');
    } else if (moment(currentDateVal).startOf('day').isBefore(moment(formatDateValue).startOf('day'))) {
        setFilterError('Select correct to/from dates');
      } else {
        dispatch(
          getFundTransactionDetails(
            formData,
            setTotalPages,
            null,
            null,
            filterTransactionType?.value,
            setShowLoader
          )
        );
      }
    
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return formData.sortColumn === columnName && formData.sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return formData.sortColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = formData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFormData({
      ...formData,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
      searchKeyword: formData.searchTxt,
    });
    setCurrentPage(1);
  };

  const getBalanceClass = (balance) => {
    if (balance > 0) return "balance credit";
    if (balance < 0) return "balance debit";
    return "balance zero";
  };

  const handleSearchText = (value) => {
    setFormData({ ...formData, searchText: value });
  };

  const handleFilterApply = () => {
    dispatch(getFundTransactionDetails(formData, setTotalPages, numberOfPage, 1, filterTransactionType?.value, setShowLoader));
  };

  const getTableClass = () => {
    let classes = "tableWide table-height cus-left-right-col-layout";
    if (showLoader) {
      classes += " disableTble";
    }
    return classes;
  };

  const fetchSuperAdminUsers = async () => {
    try {
      let usersRes = await getSuperAdminUsers();
      if (usersRes?.data?.Status === 200) {
        if (usersRes.data.EntityList.length) {
          let users = getSelectList(usersRes.data.EntityList, 'id', 'userName');
          setSuperAdmins(users);
        }
      } else {
        console.error("Failed to fetch super admin users");
      }
    } catch (error) {
      console.error("Failed to fetch super admin users", error);
    }
  };

  const handleSelectUser = (e) => {
    setFormData({ ...formData, userDetail: e, actionByUserId: e?.value ? e?.value : 0 });
    if (formData.pageIndex === 1) {
      dispatch(getFundTransactionDetails(formData, setTotalPages, numberOfPage, 1, filterTransactionType?.value, setShowLoader));
    }
  };

  const renderDescriptionLink = (d) => {
    if (d.linkedTaskId > 0) {
      return <Link to={`/tasks/${d.linkedTaskId}`}>{d?.description}</Link>;
    }
    if (d.linkedCarrierConnectId > 0) {
      return <Link to={`/carrier-connect/${d.linkedCarrierConnectId}`} state={{ data: d.linkedCarrierConnectId, isEdit: false }}>{d?.description}</Link>;
    }
    // RETURN PACKAGE PAYMENT / RETURN PRODUCT PAYMENT — when there is no
    // linkedTaskId the description embeds the return package id / product id.
    // Parse it and render the description as a link to the respective edit
    // screen so users can navigate from the fund history.
    const desc = d?.description || '';
    const dateString = moment(d?.createdDate || new Date()).format('MM-DD-YYYY');
    const dateSegment = `fd-${dateString}-3pl`;
    const navState = { view: true, date: dateString };
    const packageId = desc.match(/Package\s*Tracking\s*Id\s*#(\d+)/i)?.[1];
    if (packageId) {
      return (
        <Link to={`/incoming-packages/${dateSegment}/${packageId}`} state={navState}>
          {desc}
        </Link>
      );
    }
    const productId = desc.match(/Product\s*Id\s*#(\d+)/i)?.[1];
    if (productId) {
      return (
        <Link to={`/incoming-product/${dateSegment}/${productId}`} state={navState}>
          {desc}
        </Link>
      );
    }
    return <>{d?.description}</>;
  };

  const handleDownloadExport = async () => {
    let data = {
      ...formData,
      isExportAllData: true,
      transactionType: filterTransactionType?.value
    }
    setShowLoader(true);
    let res = await exportFundDetails(data);
    if (res?.data?.Status === 200) {
      toast.success(res?.data?.Entity);
    } else {
      toast.error("Something went wrong. Please try again later.");
    }
    setShowLoader(false);
  };

  const handleBack = () => {
    navigate("/fundManagement");
    dispatch(emptyFundTransactionList());
  };

  const topUpRefreshFilter = getTopUpRefreshFilter(currentPage, numberOfPage, formData, UserDetails);
  const selectedTopUpFundList = getSelectedTopUpFundList(formData);

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          Fund Management
          <FundHistoryHeaderActions
            employeePermissions={props.employeePermissions}
            handleApply={handleApply}
            handleBack={handleBack}
            handleDownloadExport={handleDownloadExport}
            openAdjustmentModal={() => setpriceModalShow(true)}
            openTopUpModal={() => setModalShow(true)}
            showLoader={showLoader}
          />
        </div>

        <div className="fontFix">
          {isIncludeAllData && (
            <SearchProduct
              showSearch={true}
              searchTxt={formData.searchText}
              setSearchTxt={handleSearchText}
              handleReset={() => handleApply("reset")}
              handleSearchFilter={handleFilterApply}
              placeHolderText="Search by Action By, Transaction Type, Company Name, Seller Name, Seller Code, STE Code, Carrier or Description"
            />
          )}
          <div className="mb-3">
            {!isIncludeAllData && (
              <Row>
                <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                  <Form.Group>
                    <div className="input-label-Created-date">
                      Company Name : {formData?.companyName}
                    </div>
                  </Form.Group>
                </div>

                <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                  <Form.Group>
                    <div className="input-label-Created-date">
                      Seller Name : {formData?.sellerName}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                  <Form.Group>
                    <div className="input-label-Created-date">
                      Threshold Value : <i className="fa fa-usd" aria-hidden="true"></i>{" "}
                      {formData?.threshold
                        ? formatNumberWithCommas(formData?.threshold)
                        : 0}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                  <Form.Group>
                    <div className="input-label-Created-date">
                      Available Balance:{" "}
                      <i className="fa fa-usd" aria-hidden="true"></i>{" "}
                      {formData?.availableAmount &&
                        formatNumberWithCommas(formData?.availableAmount)}
                    </div>
                  </Form.Group>
                </div>
              </Row>
            )}
          </div>

          <div className="mb-3 zIndex2">
            <Row>
              <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                <div className="mb-2">
                  <div className="input-label-Created-date">From:</div>
                  <div>
                    <DatePicker
                      className="date-picker form-control"
                      showIcon
                      dateFormat="MM-dd-yyyy"
                      selected={formatDateValue && new Date(formatDateValue)}
                      onChange={(selectedDate) =>
                        handleDateChange(selectedDate, "dateFrom")
                      }
                    />
                  </div>
                  <span className="error">{filterError}</span>
                </div>
              </div>
              <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                <div>
                  <div className="input-label-Created-date">To:</div>
                  <DatePicker
                    className="date-picker form-control"
                    showIcon
                    dateFormat="MM-dd-yyyy"
                    selected={currentDateVal}
                    onChange={(dateTo) => handleDateChange(dateTo, "dateTo")}
                  />
                </div>
              </div>
              {isIncludeAllData &&
                <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10">
                  <div>Select User</div>
                  <Select
                    isClearable
                    onChange={(e) => handleSelectUser(e)}
                    options={superAdmins}
                    classNamePrefix="list"
                    placeholder={"Select User"}
                    value={formData.userDetail}
                  />
                </div>
              }
              <div className="col-lg-3 col-md-12 col-sm-12 mobMb-10 transaction-filter">
                <div>Transaction Type</div>
                <Select
                  onChange={(e) => setfilterTransactionType(e)}
                  options={fundTransactionData}
                  classNamePrefix="list"
                  placeholder={"Transaction Type"}
                  value={filterTransactionType}
                />
              </div>
            </Row>
          </div>
        </div>

        {showLoader && <LoaderSpinner />}
        <div className="main_content_table_history zIndex1">
          <div className="incomingTbl">
            <Table className={getTableClass()}>
              <thead>
                <tr className="trow">
                  <th width="4%">#</th>
                  <th className="trows-s" width="12%">
                    <button
                      className={handleSortingClass("createdDate")}
                      onClick={(e) => handleSortingColumn(e, "createdDate")}
                      id="createdDate"
                    >
                      Date {" "}
                      <i
                        className={handleSortingClass("createdDate", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>

                  {isIncludeAllData && <th className="trows-s" width="12%">
                    <button
                      className={handleSortingClass("creditCompanySellerName")}
                      onClick={(e) => handleSortingColumn(e, "creditCompanySellerName")}
                      id="creditCompanySellerName"
                    >
                      Company / Seller Name {" "}
                      <i
                        className={handleSortingClass("creditCompanySellerName", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>}
                  <th className="trows-s" width="10%">
                    <button
                      className={handleSortingClass("transactionType")}
                      onClick={(e) => handleSortingColumn(e, "transactionType")}
                      id="transactionType"
                    >
                      Transaction Type {" "}
                      <i
                        className={handleSortingClass("transactionType", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th className="trows-s" width="5%">
                    <button
                      className={handleSortingClass("carrierName")}
                      onClick={(e) => handleSortingColumn(e, "carrierName")}
                      id="carrierName"
                    >
                      Carrier {" "}
                      <i
                        className={handleSortingClass("carrierName", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th className="trows-s" width="5%">
                    <button
                      className={handleSortingClass("debit")}
                      onClick={(e) => handleSortingColumn(e, "debit")}
                      id="debit"
                    >
                      Debit {" "}
                      <i
                        className={handleSortingClass("debit", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th className="trows-s" width="5%">
                    <button
                      className={handleSortingClass("credit")}
                      onClick={(e) => handleSortingColumn(e, "credit")}
                      id="credit"
                    >
                      Credit {" "}
                      <i
                        className={handleSortingClass("credit", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th className="trows-s" width="10%">
                    <button
                      className={handleSortingClass("closingBalance")}
                      onClick={(e) => handleSortingColumn(e, "closingBalance")}
                      id="closingBalance"
                    >
                      Closing Balance {" "}
                      <i
                        className={handleSortingClass("closingBalance", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  {isIncludeAllData && <th className="trows-s" width="7%">
                    <button
                      className={handleSortingClass("actionByUserName")}
                      onClick={(e) => handleSortingColumn(e, "actionByUserName")}
                      id="actionByUserName"
                    >
                      Action By {" "}
                      <i
                        className={handleSortingClass("actionByUserName", true)}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>}
                  <th className="trows-s descriptioncolumn" width="10%">Description</th>
                </tr>
              </thead>
              <tbody>
                {fundTransactionDetails?.length > 0 &&
                  fundTransactionDetails?.map((d, i) => (
                    <tr key={d?.id}>
                      <td>{i + 1}</td>
                      <td>
                        {moment(d?.createdDate).format(
                          "MM-DD-YYYY | h:mm:ss A"
                        )}
                      </td>
                      {isIncludeAllData && <td className="trows-s" width="5%">{d.creditCompanySellerName}</td>}
                      <td>{d?.transactionType}</td>
                      <td>{d?.carrierName || '-'}</td>
                      <td>
                        <span className="debit">
                          $ {formatNumberWithCommas(d?.debit)}
                        </span>
                      </td>
                      <td>
                        <span className="credit">
                          $ {formatNumberWithCommas(d?.credit)}
                        </span>
                      </td>
                      <td>
                        <span className={getBalanceClass(d?.closingBalance)}>
                          $ {formatNumberWithCommas(d?.closingBalance)}
                        </span>
                      </td>
                      {isIncludeAllData && <td className="trows-s" width="5%">{d.actionByUserName}</td>}
                      <td>
                        {renderDescriptionLink(d)}
                      </td>
                    </tr>
                  ))}

                {fundTransactionDetails && !fundTransactionDetails.length &&
                  <tr>
                    <td colSpan={12} align="center">No Record Found...</td>
                  </tr>
                }
              </tbody>
            </Table>
          </div>
        </div>
        {fundTransactionDetails?.length > 0 && (
          <BatchPagination
            gridData={fundTransactionDetails}
            totalVisualRecords={fundTransactionDetails.length}
            totalRecords={fundTransactionTotalRecord.TotalRecords}
            numberOfPage={numberOfPage}
            numOfPage={numOfPage}
            currentPage={currentPage}
            totalPages={totalPages}
            loader={showLoader}
            setCurrentPage={setCurrentPage}
            setNumberOfPage={setNumberOfPage}
          />
        )}

        <FundHistoryModals
          activeSellerList={activeSellerList}
          dispatch={dispatch}
          modalShow={modalShow}
          priceModalShow={priceModalShow}
          selectedTopUpFundList={selectedTopUpFundList}
          setModalShow={setModalShow}
          setpriceModalShow={setpriceModalShow}
          setShowRechargePopup={setShowRechargePopup}
          showRechargePopup={showRechargePopup}
          topUpRefreshFilter={topUpRefreshFilter}
          userDetails={UserDetails}
        />
      </div>
    </main>
  );
}

FundmanagementHistory.propTypes = {
  employeePermissions: PropTypes.array,
};
